import styled from "@emotion/styled"
import Typography from "@mui/material/Typography"
import { breakpoints } from "../../theme/mediaQueries"
import { sizes } from "../../theme/sizes"
import { colors } from "../../theme/colors"

/* ------------------------------------------------------------------ */
/* Root — full-width section with vertical padding                     */
/* ------------------------------------------------------------------ */
export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${sizes.spacing[40]}px;
  padding: ${sizes.spacing[48]}px 0;

  @media (min-width: ${breakpoints.lg}px) {
    padding: ${sizes.spacing[64]}px 0;
    gap: ${sizes.spacing[48]}px;
  }
`

/* ------------------------------------------------------------------ */
/* Header — title row + subtitle, right-aligned (RTL start)            */
/* ------------------------------------------------------------------ */
export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${sizes.spacing[16]}px;
  width: 100%;
`

/* ------------------------------------------------------------------ */
/* Title row — chevron icon + title text                                */
/* ------------------------------------------------------------------ */
export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.spacing[8]}px;

  @media (min-width: ${breakpoints.lg}px) {
    gap: ${sizes.spacing[6]}px;
  }
`

export const Title = styled(Typography)`
  color: ${colors.light.text.primary};
`

export const ChevronWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`

export const Subtitle = styled(Typography)`
  color: ${colors.light.text.primary};
`

/* ------------------------------------------------------------------ */
/* Swiper wrapper — horizontal scroll for all breakpoints              */
/* ------------------------------------------------------------------ */
export const SwiperWrapper = styled.div`
  width: 100%;
  overflow: hidden;

  .swiper {
    width: 100%;
    overflow: visible;
    padding: 0 !important;
  }

  .swiper-slide {
    height: auto;
  }

  .swiper-pagination {
    position: relative;
    margin-top: ${sizes.spacing[24]}px;
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: ${colors.primitives.neutral300};
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: ${colors.primitives.primary500};
  }
`

/* ------------------------------------------------------------------ */
/* Testimonial card                                                     */
/* ------------------------------------------------------------------ */
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizes.spacing[16]}px;
  padding: ${sizes.spacing[24]}px;
  border-radius: ${sizes.borderRadius[24]}px;
  border: 1px solid ${colors.primitives.neutral300};
  background-color: ${colors.primitives.neutral0};
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`

/* ------------------------------------------------------------------ */
/* Card image — circular avatar                                         */
/* ------------------------------------------------------------------ */
export const AvatarWrapper = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: ${sizes.borderRadius.full}px;
  overflow: hidden;
  flex-shrink: 0;
`

/* EGDE-597: the avatar honours the responsiveImage Mobile Image. Toggled in CSS
   (not via a viewport hook) so server and client markup agree — see HeroBanner
   for the same pattern. */
export const AvatarDesktopLayer = styled.div`
  position: absolute;
  inset: 0;
  display: none;

  @media (min-width: ${breakpoints.lg}px) {
    display: block;
  }
`

export const AvatarMobileLayer = styled.div`
  position: absolute;
  inset: 0;
  display: block;

  @media (min-width: ${breakpoints.lg}px) {
    display: none;
  }
`

export const AvatarPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.primitives.neutral200};
  border-radius: ${sizes.borderRadius.full}px;
`

/* ------------------------------------------------------------------ */
/* Card content — name, role, testimonial text                          */
/* ------------------------------------------------------------------ */
export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizes.spacing[8]}px;
  width: 100%;
`

export const CardTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizes.spacing[4]}px;
  width: 100%;
`

export const EmployeeName = styled(Typography)`
  color: ${colors.light.text.primary};
  text-align: center;
  font-weight: 700 !important;
`

export const EmployeeRole = styled(Typography)`
  color: ${colors.light.text.primary};
  text-align: center;
`

export const TestimonialText = styled(Typography)`
  color: ${colors.light.text.primary};
  text-align: center;
`
